import React from 'react'

const faqs = [
  {
    id: 1,
    answer:
      "A block of telephone numbers is assigned to an organization by a telecommunications service provider. These numbers can then be distributed to various devices or employees within the organization.",
    question: "Assignment of Numbers",
  },
  {
    id: 2,
    answer:
      "When an external call is made to any of these DID numbers, the service provider's switch directs the call to the organization's PBX (Private Branch Exchange) system.",
    question: "Routing Calls",
  },
  {
    id: 3,
    answer:
      "The PBX system recognizes the specific DID number that has been dialed and routes the call to the corresponding extension within the organization. This allows the call to go directly to the intended recipient, bypassing the need for a receptionist or operator.",
    question: "PBX Processing",
  },
  {
    id: 4,
    answer:
      "Besides routing incoming calls, DID numbers often support various features such as voicemail, call forwarding, and call recording, depending on the organization's PBX capabilities.",
    question: "Enhanced Features",
  },
  // More questions...
];

function Did() {
  return (
    <div className="bg-white py-2">
      <div className="flex flex-col md:flex-row items-center justify-between p-6 ">
        {/* Left Content */}
        <div className="md:w-1/2 p-4">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">DiDRoute</h1>
          <ul className="list-disc list-inside text-gray-600 space-y-2">
            <p className="text-lg text-gray-600">
              A DID (Direct Inward Dialing) number is a virtual phone number
              that allows a company to assign individual phone numbers to each
              of its employees without requiring a separate physical phone line
              for each one. This technology is particularly useful for
              businesses that need to manage a large volume of incoming calls
              efficiently.
            </p>
          </ul>
        </div>

        {/* Right Image */}
        <div className="md:w-1/2 p-4">
          <img
            src="https://images.unsplash.com/photo-1606857521015-7f9fcf423740?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1344&h=1104&q=80"
            alt="Placeholder"
            className="rounded-lg shadow-lg"
          />
        </div>
      </div>

      {/* section */}

      <div className="bg-white">
        <div className="mx-auto max-w-7xl px-6 py-16 sm:py-24 lg:px-8">
          <h2 className="text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">
            Here's how DID works:
          </h2>
          {/* <p className="mt-6 max-w-2xl text-base/7 text-gray-600">
            Toll-Free Calling is a thing in lots of countries, and it happens by
            setting aside special phone numbers called Toll-Free 800 Numbers.
            People can dial these numbers without worrying about getting
            charged. Check out these examples:
          </p> */}
          <div className="mt-20">
            <dl className="space-y-16 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-16 sm:space-y-0 lg:gap-x-10">
              {faqs.map((faq) => (
                <div key={faq.id}>
                  <dt className="text-base/7 font-semibold text-gray-900">
                    {faq.question}
                  </dt>
                  <dd className="mt-2 text-base/7 text-gray-600">
                    {faq.answer}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>

      {/* section */}
      <div className="flex flex-col md:flex-row items-center justify-between p-6 ">
        {/* Left Content */}
        <div className="md:w-1/2 p-4">
          {/* <h1 className="text-4xl font-bold text-gray-800 mb-4">
            DID numbers are especially beneficial in creating a local presence,
            as a company can have multiple DID numbers from different area codes
            or even different countries, all routed to their central office.
            This makes it easier for customers in different regions to reach the
            business while perceiving it as local.
          </h1> */}
          <p className="text-lg/7 text-gray-600">
            DID numbers are especially beneficial in creating a local presence,
            as a company can have multiple DID numbers from different area codes
            or even different countries, all routed to their central office.
            This makes it easier for customers in different regions to reach the
            business while perceiving it as local.
          </p>
        </div>

        {/* Right Image */}
        <div className="md:w-1/2 p-4">
          <img
            src="https://images.unsplash.com/photo-1606857521015-7f9fcf423740?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1344&h=1104&q=80"
            alt="Placeholder"
            className="rounded-lg shadow-lg"
          />
        </div>
      </div>
    </div>
  );
}

export default Did